import { render } from "./UnassignedPatientVisitsMap.vue?vue&type=template&id=3b8b70cc"
import script from "./UnassignedPatientVisitsMap.ts?vue&type=script&lang=js&external"
export * from "./UnassignedPatientVisitsMap.ts?vue&type=script&lang=js&external"

import "./UnassignedPatientVisitsMap.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__